module.exports = __webpack_public_path__ + "static/media/piano.31a6765e.wav";